import BaseMap from "../BaseMap";
import MapInterface from "../../Interfaces/MapInterface";
import Fauci from "../Fauci";
import Virus from "../Virus";
import Bat from "../Bat";
import Portal from "../Portal";

export default class LevelTwo extends BaseMap implements MapInterface
{
    el: HTMLElement;

    constructor()
    {
        super();
        this.el = document.createElement('div');
        this.el.id = 'LevelTwo';
        this.el.classList.add('Level');

        let v1 = new Virus(Math.floor(Math.random() * 50) + 1);
        let v2 = new Virus(Math.floor(Math.random() * 50) + 1);
        let v3 = new Virus(Math.floor(Math.random() * 50) + 1);
        let v4 = new Virus(Math.floor(Math.random() * 50) + 1);

        this.el.appendChild(v1.render());
        this.el.appendChild(v2.render());
        this.el.appendChild(v3.render());
        this.el.appendChild(v4.render());

        let b1 = new Bat(Math.floor(Math.random() * 60) + 1);
        let b2 = new Bat(Math.floor(Math.random() * 60) + 1);
        let b3 = new Bat(Math.floor(Math.random() * 60) + 1);
        let b4 = new Bat(Math.floor(Math.random() * 60) + 1);

        this.el.appendChild(b1.render());
        this.el.appendChild(b2.render());
        this.el.appendChild(b3.render());
        this.el.appendChild(b4.render());
    }

    render(): HTMLElement
    {
        let helper = new Fauci;
        helper.say('Bats move faster');
        this.el.appendChild(helper.render());

        setTimeout(() => {
            helper.hide();
        }, 3000);

        setTimeout(() => {
            helper.say('Flatten the curve!');
            helper.show();
        }, 10000);

        setTimeout(() => {
            helper.hide();
        }, 13000);

        setTimeout(() => {
            helper.say('Social Distancing!');
            helper.show();
        }, 20000);

        setTimeout(() => {
            helper.hide();
        }, 23000);

        let portal = new Portal('LevelThreePortal');
        let l2El = portal.render()
        this.game.elements.push(l2El);
        portal.setGame(this.game);
        this.el.appendChild(l2El);

        return this.el;
    }
}